export const defaultBomObjectMetadata = {
    childrenLength: 0,
    environmental: 0,
    economic: 0,
    social: 0,
    carbonEmission: 0,
    price: 0,
    insertDataOnly: 0,
    insertDataInsteadOfInsertModel: 0,
    insertModelPlusData: 0,
    insertModelPlusTemplateFilePlusData: 0,
    outdatedInDesign: 0,
    removedFromLibrary: 0
};